// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"../../../themes/Colors.css\"","primary":"#f24d0c","cont":"GameResult_cont__ndRbH","result":"GameResult_result__h9nfu","resultText":"GameResult_resultText__Hn_XV"};